import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NumberRangeOverviewPanel, {
  type NumberRangeOverviewPanelProps,
} from "./NumberRangeOverviewPanel";

export type NumberRangeOverviewDialogProps = NumberRangeOverviewPanelProps & {
  open: boolean;
  onClose: () => void;
};

export default function NumberRangeOverviewDialog({
  open,
  onClose,
  ...panelProps
}: NumberRangeOverviewDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle sx={{ pr: 6 }}>
        Event code structure
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <NumberRangeOverviewPanel {...panelProps} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
